import Vue from 'vue'
import VueRouter from 'vue-router'
import Giftbag from '../views/Giftbag.vue'
import Message from '../views/message.vue'
import Other from '../views/other.vue'
import Vouchers from '../views/vouchers.vue'
import Usecoupon from '../views/usecoupon.vue'
import Iosother from '../views/iosother.vue'
import Recharge from '../views/recharge.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/giftbag',
        name: 'Giftbag',
        component: Giftbag
    },
    {
        path: '/message',
        name: 'message',
        component: Message

    },
    {
        path: '/other',
        name: 'Other',
        component: Other

    },
    {
        path: '/iosother',
        name: 'Iosother',
        component: Iosother

    },
    {
        path: '/vochers',
        name: 'Vouchers',
        component: Vouchers

    },
    {
        path: '/usecoupon',
        name: 'Usecoupon',
        component: Usecoupon
    },
    {
        path: '/recharge',
        name: 'Recharge',
        component: Recharge
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router